// T331 — one definition of a score band.
//
// The bands were a backend const inside analyticsFunnel.js, which was fine
// while only the analytics rollups used them. Drilling from a band bar into the
// application board needs the client to decide which band a row falls in, and a
// second copy of these thresholds is how the bar and the list it links to start
// disagreeing about what "40+" contains — the same failure the `goneJobQuery`
// comment in shared/src/job.js was written about.
//
// Ordered high-to-low: `bandOf` returns the FIRST threshold met, so the order
// is load-bearing, not cosmetic.
export const SCORE_BANDS = Object.freeze([
  { label: '40+', min: 40 },
  { label: '30\u201339', min: 30 },
  { label: '20\u201329', min: 20 },
  { label: '10\u201319', min: 10 },
  { label: '0\u20139', min: 0 },
  { label: '<0 (vetoed)', min: -Infinity },
]);

/**
 * The band a score falls in, or null when there is no score.
 *
 * null rather than the bottom band: `Number(null)` is 0, and a row that was
 * never scored is not a row that scored zero. This codebase has been bitten by
 * that coercion before.
 */
export function bandOf(score) {
  // `''` is absent too, and it is the one that slips through: `'' == null` is
  // false and `Number('')` is 0, so an empty string files under '0-9'. Caught by
  // this module's own test before it shipped; the same coercion has bitten this
  // codebase in three other places.
  if (score == null || score === '') return null;
  const n = Number(score);
  if (!Number.isFinite(n)) return null;
  return SCORE_BANDS.find((b) => n >= b.min)?.label ?? null;
}
